// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__ssYIe","Open":"SideDrawer_Open__2p_3o","Close":"SideDrawer_Close__2ZrFM","Logo":"SideDrawer_Logo__3pw0a"};